module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bo-ee5938f07b3324e9af6d22cc2b9dc1ac.svg";